export default (eventType) => {
  const activeClass = 'accordion--active';
  const getContainer = el => el.closest('[data-accordian-container]').dataset.accordianContainer;
  const getRow = el => el.closest('[data-accordian-row]');
  const resetRows = el => [...document.querySelectorAll(`[data-accordian-container="${getContainer(el)}"] [data-accordian-row]`)].filter(row => row !== getRow(el)).map(row => row.classList.remove(activeClass));

  const selectRow = el => !getRow(el).classList[eventType === 'click' && getRow(el).matches('.' + activeClass) ? 'remove' : 'add'](activeClass);

  const event = ({ target }) => {
    // Ignores clicks on non-accordion items
    if ( getRow(target) === null ) {
      return;
    }
    target.dataset.accordian;
    resetRows(target);
    selectRow(target);
  };

  document.addEventListener(eventType, event);

  return { remove: () => document.removeEventListener(eventType, event) };
};
